import { Network } from '@kattana-io/common';
import Image from '../../../atoms/Image';
import { ITickerDisplayData } from '../../../hooks/useTicker';
import { getNetworkFlags } from '../../../wallet/helpers';
import { IPoolWidgetLinks } from '../useTickerPool';

import coingecko from '../../../assets/images/coingecko.svg';
import coinmarketcap from '../../../assets/images/coinmarketcap.svg';
import metamask from '../../../assets/images/metamask.svg';
import twitter from '../../../pages/TokenPage/images/twitter.svg';
import telegramIcon from '../../../pages/TokenPage/images/telegram.svg';
import bubblemapsIcon from '../../../assets/images/bubblemaps.svg';

import './styles.scss';

const addToWallet = async (
  address: string,
  slug: string,
  decimals: number,
  logo: string
) => {
  try {
    const wasAdded = await (window as any).ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address, // The address that the token is at.
          symbol: slug, // A ticker symbol or shorthand, up to 5 chars.
          decimals, // The number of decimals in the token
          image: logo, // A string url of the token logo
        },
      },
    });

    if (!wasAdded) {
      console.warn('Asset wasnt added due to user rejection');
    }
  } catch (error) {
    console.warn(error);
  }
};

const BubblemapsNetwork: Record<string, string> = {
  ETH: 'eth',
  BSC: 'bsc',
  FTM: 'ftm',
  AVAX: 'avax',
  CRONOS: 'cro',
  ARBITRUM: 'arbi',
  POLYGON: 'poly',
};

interface IPoolLinksProps extends Partial<IPoolWidgetLinks> {
  ticker: ITickerDisplayData;
  network?: Network;
}

const PoolLinks = ({
  website,
  coingecko_id,
  coinmarketcap_id,
  telegram,
  twitter_id,
  logo,
  ticker,
  network,
}: IPoolLinksProps) => {
  const isEVM = network ? getNetworkFlags(network.chain).isEVM : false;
  const bubblemaps = network ? BubblemapsNetwork[network.getSlug()] : undefined;

  return (
    <div className='pool_links'>
      {website && (
        <a
          href={website}
          className='pool_links__item pool_links__item--icon icon-discovery'
          target='_blank'
          rel='noreferrer'
        />
      )}
      {coingecko_id && (
        <a
          href={`https://www.coingecko.com/en/coins/${coingecko_id}`}
          className='pool_links__item'
          target='_blank'
          rel='noreferrer'
        >
          <Image src={coingecko} size='s' />
        </a>
      )}
      {coinmarketcap_id && (
        <a
          href={`https://coinmarketcap.com/currencies/${coinmarketcap_id}/`}
          className='pool_links__item'
          target='_blank'
          rel='noreferrer'
        >
          <Image src={coinmarketcap} size='s' />
        </a>
      )}
      {telegram && (
        <a
          href={`https://t.me/${telegram}/`}
          className='pool_links__item'
          target='_blank'
          rel='noreferrer'
        >
          <Image src={telegramIcon} size='s' />
        </a>
      )}
      {twitter_id && (
        <a
          href={`https://twitter.com/${twitter_id}/`}
          className='pool_links__item'
          target='_blank'
          rel='noreferrer'
        >
          <Image src={twitter} size='s' />
        </a>
      )}
      {isEVM && !!logo && !!ticker.base_address && (
        <div
          className='pool_links__item'
          onClick={() =>
            addToWallet(
              ticker.base_address,
              ticker.base,
              ticker.base_decimals,
              logo
            )
          }
        >
          <Image src={metamask} size='s' />
        </div>
      )}
      {bubblemaps && (
        <a
          href={`https://app.bubblemaps.io/${bubblemaps}/token/${ticker.base_address}`}
          className='pool_links__item'
          target='_blank'
          rel='noreferrer'
        >
          <Image src={bubblemapsIcon} size='s' />
        </a>
      )}
    </div>
  );
};

export default PoolLinks;
